import { Component, OnInit, Input } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';
import { ScheduledClass } from '@widgets/models/ScheduledClass';

@Component({
  selector: 'lms-scheduled-classes',
  templateUrl: './scheduled-class.component.html',
  styleUrls: ['./scheduled-class.component.scss']
})
export class ScheduledClassComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public scheduledClass: ScheduledClass;

  constructor() {}

  public ngOnInit(): void {
    this.scheduledClass = this.data['scheduledClass'];
  }
}
